/* narin. — lightbox: one image at a time, navigated by the bottom thumbnail
   rail, by swipe (touch), and by arrow keys. */
(function () {
  function content(modal) {
    return modal.querySelector('.product-media-modal__content');
  }

  function orderedIds(modal) {
    return Array.prototype.map.call(
      modal.querySelectorAll('.narin-lightbox-thumb'),
      function (t) { return t.getAttribute('data-target-media'); }
    );
  }

  function activeId(modal) {
    var c = content(modal);
    var active = c && c.querySelector(':scope > [data-media-id].active');
    return active ? active.getAttribute('data-media-id') : null;
  }

  function setActive(modal, id) {
    var c = content(modal);
    if (!c) return;
    c.querySelectorAll(':scope > [data-media-id]').forEach(function (el) {
      el.classList.toggle('active', el.getAttribute('data-media-id') === id);
    });
    modal.querySelectorAll('.narin-lightbox-thumb').forEach(function (t) {
      var on = t.getAttribute('data-target-media') === id;
      t.classList.toggle('is-active', on);
      if (on && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'center' });
    });
  }

  function move(modal, dir) {
    var ids = orderedIds(modal);
    if (ids.length < 2) return;
    var i = ids.indexOf(activeId(modal));
    if (i === -1) i = 0;
    var next = (i + dir + ids.length) % ids.length;
    setActive(modal, ids[next]);
  }

  // Click a thumbnail → show that image
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('.narin-lightbox-thumb');
    if (!thumb) return;
    var modal = thumb.closest('product-modal');
    if (modal) setActive(modal, thumb.getAttribute('data-target-media'));
  });

  // Chevron prev/next over the image — stop the event so Dawn doesn't close the modal
  function bindNav(modal) {
    if (modal.__narinNav) return;
    modal.__narinNav = true;
    modal.querySelectorAll('[data-narin-lb-prev], [data-narin-lb-next]').forEach(function (btn) {
      var dir = btn.hasAttribute('data-narin-lb-next') ? 1 : -1;
      ['pointerup', 'pointerdown', 'mousedown', 'mouseup'].forEach(function (evt) {
        btn.addEventListener(evt, function (e) { e.stopPropagation(); });
      });
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        e.preventDefault();
        move(modal, dir);
      });
    });
  }

  // Swipe left/right on the image area → prev/next
  function bindSwipe(modal) {
    var c = content(modal);
    if (!c || c.__narinSwipe) return;
    c.__narinSwipe = true;
    var x0 = null, y0 = null, t0 = 0;
    c.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      x0 = t.clientX; y0 = t.clientY; t0 = Date.now();
    }, { passive: true });
    c.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0;
      var dy = t.clientY - y0;
      var dt = Date.now() - t0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4 && dt < 700) {
        move(modal, dx < 0 ? 1 : -1);
      }
      x0 = y0 = null;
    }, { passive: true });
  }

  // Arrow keys while a modal is open
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var modal = Array.prototype.find.call(
      document.querySelectorAll('product-modal'),
      function (m) {
        return m.hasAttribute('open') || (m.offsetParent !== null && getComputedStyle(m).display !== 'none');
      }
    );
    if (!modal) return;
    move(modal, e.key === 'ArrowRight' ? 1 : -1);
  });

  // Dawn's media-modal closes on any pointerup outside a video/3D element.
  // Stop pointer events on the thumbnail rail from bubbling to it.
  function guardRail(rail) {
    if (rail.__narinGuard) return;
    rail.__narinGuard = true;
    ['pointerup', 'pointerdown', 'mouseup', 'mousedown'].forEach(function (evt) {
      rail.addEventListener(evt, function (e) { e.stopPropagation(); });
    });
  }

  // Keep the active thumbnail in sync when the modal opens on a specific image
  function observe(modal) {
    var c = content(modal);
    if (!c || c.__narinObs) return;
    c.__narinObs = true;
    var obs = new MutationObserver(function () {
      var active = c.querySelector(':scope > [data-media-id].active');
      if (!active) return;
      var id = active.getAttribute('data-media-id');
      modal.querySelectorAll('.narin-lightbox-thumb').forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-target-media') === id);
      });
    });
    obs.observe(c, { attributes: true, attributeFilter: ['class'], subtree: true });
  }

  function init() {
    document.querySelectorAll('product-modal').forEach(function (modal) {
      observe(modal);
      bindSwipe(modal);
      bindNav(modal);
    });
    document.querySelectorAll('.narin-lightbox-thumbs').forEach(guardRail);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
